import { Box } from '@everlywell/ui-kit';
import React from 'react';

type ApplePayWidgetProps = {
  amount: string;
};

/**
 * Wrapper for Apple Pay MMerchandising Widget.
 */
function ApplePayWidget({
  amount,
  ...containerProps
}: ApplePayWidgetProps): JSX.Element | null {
  if (!process.env.APPLE_PAY_TOKEN) {
    return null;
  }

  return (
    <Box
      sx={{
        '*': {
          /** from apple pay guideline  */
          '--apple-pay-text-color-dark': 'var(--apple-pay-text-color, #1d1d1f)',
          display: 'flex',
          width: '100%',
          marginTop: '4px',
          textAlign: 'left',
          justifyContent: 'center',
          paddingLeft: 4,
          paddingRight: 4,
        },
        '> *': {
          maxWidth: 'none !important',
        },
      }}
      {...containerProps}
      dangerouslySetInnerHTML={{
        __html: `<apple-pay-merchandising button-style="black" amount="${amount}" type="price" theme="dark" locale="en-US" country-code="US" currency-code="USD"></apple-pay-merchandising>`,
      }}
    ></Box>
  );
}

export default ApplePayWidget;
